import { Loader } from '@googlemaps/js-api-loader';
import { logger } from '@pkg/logger';

let googleMapsLoader: Loader | null = null;
let isGoogleMapsLoaded = false;
let cachedApiKey: string | null = null;

export function useGoogleMaps() {
  const loadGoogleMaps = async() => {
    if (isGoogleMapsLoaded) {
      return;
    }

    if (!cachedApiKey) {
      try {
        const { apiKey } = await $fetch<{ apiKey: string }>('/api/google-maps-api-key');
        cachedApiKey = apiKey;
      } catch (error) {
        logger.error('Failed to fetch Google Maps API key', error);
        return;
      }
    }

    const apiKey = cachedApiKey;

    if (!googleMapsLoader) {
      googleMapsLoader = new Loader({
        apiKey,
        version: 'beta',
        libraries: ['maps', 'marker'],
      });
    }

    try {
      await googleMapsLoader.load();
      isGoogleMapsLoaded = true;
    } catch (error) {
      logger.error('Failed to load Google Maps:', error);
      // add analytics here
      // throw error;
    }
  };

  return {
    loadGoogleMaps,
    isGoogleMapsLoaded: () => isGoogleMapsLoaded,
  };
}
